import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChatContentComponent } from './chat-content/chat-content.component';
import { ChatComponent } from './chat/chat.component';


const routes: Routes = [
  {
    path: '',
    component: ChatComponent,
    children: [
      {
        path: ':uuid',
        component: ChatContentComponent,
      }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatRoutingModule { }
